module.exports = __webpack_public_path__ + "static/media/stockhausen_graz_1.36b166a0.jpg";